import { doc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { isPlaceholderClinicName } from './loginRestrictions';

/**
 * Persist clinicId/role from resolved session onto users/{uid} so Firestore rules match the app.
 */
export async function syncUserClinicToFirestore(userData) {
  if (!userData?.uid || userData.role === 'super_admin') return;
  if (!userData.clinicId) return;

  try {
    await setDoc(
      doc(db, 'users', userData.uid),
      {
        clinicId: userData.clinicId,
        ...(userData.clinicName && !isPlaceholderClinicName(userData.clinicName)
          ? { clinicName: userData.clinicName }
          : {}),
        ...(userData.role ? { role: userData.role } : {}),
        updatedAt: new Date(),
      },
      { merge: true }
    );
  } catch (err) {
    console.warn('[syncUserClinicToFirestore] failed:', err?.message || err);
  }
}
